import * as ObjectSegFilterTypes from 'customer-data-filters-ui/converters/objectSeg/ObjectSegFilterTypes';
import * as OperatorTypes from '../ObjectSegOperatorTypes';
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import get from 'transmute/get';
import invariant from 'react-utils/invariant';
import protocol from 'transmute/protocol';
import { List } from 'immutable';
import { communicationFilterFamilyToChannel, isCommunicationSubscriptionFilterFamily, SUBSCRIPTION_TYPE } from '../communicationSubscriptionFilters/communicationSubscriptionFilters';
const isImmutableList = list => {
  if (List.isList(list)) {
    return true;
  }
  return false;
};
function maybeImmutableListToArray(list) {
  if (isImmutableList(list)) {
    return list.toArray();
  }
  throw new Error(`${list} is not an immutable list`);
}
const _toCommunicationSubscriptionFilter = (optStatus, operator, filterFamily) => {
  if (!isCommunicationSubscriptionFilterFamily(filterFamily)) {
    throw new Error(`${filterFamily} is not a communication subscription filter family`);
  }
  return {
    filterType: ObjectSegFilterTypes.COMMUNICATION_SUBSCRIPTION,
    acceptedOptStates: [optStatus],
    subscriptionIds: maybeImmutableListToArray(get('value', operator)),
    channel: communicationFilterFamilyToChannel(filterFamily),
    subscriptionType: SUBSCRIPTION_TYPE
  };
};
const invalidOperator = operator => {
  invariant(false, 'cannot convert Operator "%s" to Communication Subscription ObjectSeg filter', operator.name);
};
const toCommunicationSubscriptionFilter = protocol({
  name: 'toCommunicationSubscriptionFilter',
  args: [protocol.TYPE],
  fallback: invalidOperator
});
toCommunicationSubscriptionFilter.implement(Operators.CommunicationSubscriptionOptIn, (operator, filterFamily) => _toCommunicationSubscriptionFilter(OperatorTypes.HAS_OPTED_IN, operator, filterFamily));
toCommunicationSubscriptionFilter.implement(Operators.CommunicationSubscriptionOptOut, (operator, filterFamily) => _toCommunicationSubscriptionFilter(OperatorTypes.HAS_OPTED_OUT, operator, filterFamily));
toCommunicationSubscriptionFilter.implement(Operators.CommunicationSubscriptionNotOpted, (operator, filterFamily) => _toCommunicationSubscriptionFilter(OperatorTypes.HAS_NOT_OPTED, operator, filterFamily));
export default toCommunicationSubscriptionFilter;